module.exports = __webpack_public_path__ + "img/logo-freshsolution.6067687f.png";